export const formatTime = (milliseconds: number) => {
  if (!milliseconds) return '';
  if (milliseconds < 1000) {
    return '00:00:00';
  }
  const totalSeconds = Math.round(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const productVariantsAnimation = {
  regular: { y: 0 },
  exit: {
    y: [0, -200],
    opacity: [1, 0],
  },
};

export const bannerVariantsAnimation = {
  enter: { scale: [0, 1.1, 1], transition: { duration: 0.4 } },
  exit: {
    scale: [1, 0],
    transition: { duration: 0.2 },
  },
};
